import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PortalBaseService } from 'src/portal/portal-base.service';
import { lastValueFrom } from 'rxjs';
import { InjectorModule } from 'src/app/shared/modules/injector.module';
import { PortalSidebarMenuModel } from './portal-sidebar-menu.model';

@Injectable({
  providedIn: 'root'
})
export class PortalSidebarMenuService extends PortalBaseService {
  private router: Router;

  constructor() {
    super();
    this.router = InjectorModule.injector.get(Router);
  }

  public async getSidebarMenus(): Promise<PortalSidebarMenuModel[]> {
    const menus = await lastValueFrom(this.get<PortalSidebarMenuModel[]>(`portal/sidebar-menus`));

    if (!menus || menus.length === 0) {
      this.router.navigate(['/maintenance-mode'], { skipLocationChange: true });
      return [];
    }

    return menus ?? [];
  }
}
